<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>波次分播</div>
    </div>
    <el-row class="filter">
      <el-col>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入拣货单号或者dbid：">
                  <el-input
                    ref="inputRef"
                    v-model="form.picking_assignment_no_or_dbid"
                    placeholder="输入拣货单号或者dbid"
                    style="width: 240px"
                    @keyup.native.enter="getGoods"
                  ></el-input>
                </el-form-item>
                <el-form-item label="输入打标ID：">
                  <el-input
                    ref="inputRef2"
                    v-model="form.dbid"
                    placeholder="输入打标ID,dbid=123456"
                    @keyup.native.enter="cut"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="subCut">提交</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="restart"
                    >重新分拨</el-button
                  >
                </el-form-item>
                <audio id="audio_error" preload="auto">
                  <source src="../../assets/music/error.wav" type="audio/wav" />
                </audio>
                <audio id="audio_success" preload="auto">
                  <source
                    src="../../assets/music/success.wav"
                    type="audio/wav"
                  />
                </audio>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div style="padding: 10px 25px">
          拣货单号/中分任务ID:{{ form.picking_assignment_no }}
        </div>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <div style="margin-bottom: 0; width: 100%">
      <div v-for="(item, key) in wave_picking">
        <div
          :class="[
            { summary_box_yc: is_yc(item.wave_picking_no) },
            { summary_box_r: is_over(item.wave_picking_no) },
            { summary_box_g: item.wave_picking_no == cur_wave },
          ]"
          style="
            width: 18%;
            float: left;
            height: 10%;
            margin: 0 auto;
            margin-left: 1%;
            margin-top: 10px;
            border: 1px solid #3a8ee6;
            text-align: center;
          "
        >
          <p class="box_p">{{ item.box_no }}</p>
          <p class="box_p" style="font-size: 60px">
            {{ item.position }}
          </p>
          <p class="box_p">{{ item.wave_picking_no }}</p>
          <p class="box_p">件数:{{ item.cut_num }}/{{ item.all_num }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.init();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        picking_assignment_no_or_dbid: "",
        picking_assignment_no: "",
        box_no: "",
        dbid: "",
      },
      loading: false,
      status: "",
      curPage: 1,
      filterFold: false,
      wave_picking: [],
      cur_wave: "",
      voice: "",
      yc_wave: [],
      over_wave: [],
      dbid_mode: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  watch: {
    dbid_mode(val) {
      if (val) {
        // 如果输入的是dbid 则把第一个文本框的值丢给第二个文本框 并且直接触发分播方法
        this.$set(this.form, "dbid", this.form.picking_assignment_no_or_dbid);
        this.cut();
      }
    },
  },
  destroyed() {},
  created() {},
  methods: {
    init() {
      this.$refs.inputRef.$el.children[0].focus();
    },
    is_yc(wave_picking_no) {
      for (const key in this.yc_wave) {
        if (wave_picking_no == this.yc_wave[key]) {
          return true;
        }
      }
      return false;
    },
    is_over(wave_picking_no) {
      for (const key in this.over_wave) {
        if (wave_picking_no == this.over_wave[key]) {
          return true;
        }
      }
      return false;
    },
    addVoice(t) {
      document.getElementById(`audio_${t}`).play();
      // this.voice=new Audio("../../assets/music/8858.wav");
      // this.voice.play();
    },
    getGoods() {
      this.$http
        .post("/erp/DeviceCut/getSummary", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.dbid_mode = false;
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.addVoice("error");
            // this.$message.error(res.data.msg);
            this.$alert(res.data.msg, "错误提醒", {
              confirmButtonText: "知道了",
            });
          } else {
            this.addVoice("success");
            this.wave_picking = res.data.data.wave_picking;
            this.dbid_mode = res.data.data.dbid_mode;
            this.form.picking_assignment_no =
              res.data.data.picking_assignment_no;
            this.cur_wave = "";
            this.$refs.inputRef2.focus();
          }
        });
    },
    cut() {
      if (typeof this.form.dbid !== "undefined") {
        const dbid = this.form.dbid.split("dbid=");

        if (typeof dbid[1] !== "undefined") {
          this.$set(this.form, "dbid", dbid[1]);
        }
      }
      this.loading = true;
      this.$http.post("/erp/DeviceCut/pcCut", this.filteredForm).then((res) => {
        this.loading = false;

        if (res.data.code !== 200) {
          this.form.dbid = "";
          this.addVoice("error");
          this.$alert(res.data.msg, "错误提醒", {
            confirmButtonText: "知道了",
          });
        } else {
          if (res.data.msg != "success") {
            this.$alert(res.data.msg, "提示", {
              confirmButtonText: "知道了",
            });
          }
          if (res.data.data.is_over == 1) {
            this.addVoice("success");
            this.$alert("分拨完成", "提示", {
              confirmButtonText: "知道了",
            });
          }
          this.form.dbid = "";
          this.addVoice("success");
          this.wave_picking = res.data.data.wave_picking;
          this.cur_wave = res.data.data.cur_wave;
        }
      });
    },
    subCut() {
      this.$confirm(`汇总单尚未完成分播，是否确认提交?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "不不不",
        type: "warning",
      }).then(() => {
        this.$http
          .post("/erp/DeviceCut/subCut", this.filteredForm)
          .then((res) => {
            if (res.data.code !== 200) {
              this.addVoice("error");
              this.$alert(res.data.msg, "错误提醒", {
                confirmButtonText: "知道了",
              });
            } else {
              this.addVoice("success");
              this.yc_wave = res.data.data.yc_wave;
              this.over_wave = res.data.data.over_wave;
              this.$alert(res.data.msg, "提示", {
                confirmButtonText: "知道了",
              });
            }
          });
      });
    },
    restart() {
      this.$confirm(`确定重新开始?`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "不不不",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/DeviceCut/restart", this.filteredForm)
            .then((res) => {
              setTimeout(() => {
                this.loading = false;
              }, 200);
              if (res.data.code !== 200) {
                this.addVoice("error");
                this.$alert(res.data.msg, "错误提醒", {
                  confirmButtonText: "知道了",
                });
              } else {
                this.addVoice("success");
                this.wave_picking = res.data.data.wave_picking;
                this.cur_wave = "";
                this.form.dbid = "";
                this.yc_wave = [];
                this.over_wave = [];
                this.$refs.inputRef2.$el.children[0].focus();
                this.$alert("已重新开始", "温馨提示", {
                  confirmButtonText: "知道了",
                });
              }
            });
        })
        .catch(() => {});
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
  },
};
</script>

<style scoped>
.summary_box_g {
  background-color: yellow;
}

.summary_box_r {
  background-color: green;
}

.summary_box_yc {
  background-color: red;
}

.box_p {
  margin-top: 5px;
  margin-bottom: 5px;
}

.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/SummaryCut.vue